import styled from 'styled-components';
import AreaDevCard from '../../../new-components/cards/AreaDevCard';
import { EntityTypes } from '../../../new-lib/constants/common';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';

interface SubAreaSectionTypes {
  area: any;
}

export const SubAreaSection = ({ area }: SubAreaSectionTypes): JSX.Element => {
  const { t } = useTranslation('entity');
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const subAreaCards = area.sub_areas
    .slice(0, 8)
    .map((item: any, index: number) => {
      return (
        <AreaDevCard
          entity={item}
          entityType={EntityTypes.AREA}
          key={item.id}
          cardPosition={index}
          linkTo={`/search?areas=${item.id}`}
        />
      );
    });

  return (
    <div>
      <span className="headline-3 entity-title">
        {t('areas_in') + ` ${area.name}`}
      </span>
      {isMobile ? (
        <MobileSubAreasGrid>{subAreaCards}</MobileSubAreasGrid>
      ) : (
        <SubAreasGrid>{subAreaCards}</SubAreasGrid>
      )}
    </div>
  );
};

const SubAreasGrid = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  padding-top: 16px;
  .area-dev-card {
    width: calc(25% - 16px);
    background: #ffff;
  }
`;

const MobileSubAreasGrid = styled.div`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  padding: 16px 0px;
  .area-dev-card {
    width: 100%;
    background: #ffff;
    max-height: 200px;
  }
  .area-dev-container {
    padding: 16px;
    min-height: 218px;

    .logo-container {
      min-height: 100px;
      max-height: 100px;
    }
  }
`;
